<template>
   <div class="nav-container">
     <nav class="main-nav">
       <!-- 品牌Logo -->
       <div class="logo">
         <img src="@/assets/footer/logo.png" alt="乐天Logo">
       </div>
 
       <!-- 右侧内容容器 -->
       <div class="right-content">
         <!-- 导航菜单 -->
         <ul class="nav-menu">
           <li 
             v-for="(item, index) in navItems" 
             :key="index"
             class="nav-item"
             @mouseenter="activeIndex = index"
             @mouseleave="activeIndex = null"
           >
             <a 
               :class="{ 'active': activeIndex === index }"
               @click.prevent="handleClick(item)"
             ><span>{{ item.title }}</span> <i :class="item.icon"></i></a>
             <!-- 下拉菜单 -->
             <ul 
               v-if="item.children"
               class="dropdown-menu"
               v-show="activeIndex === index"
             >
               <li v-for="(child, cIndex) in item.children" :key="cIndex" class="dropdown-item">
                 <span @click="goTo(child)">{{ child.name }}</span>
               </li>
             </ul>
           </li>
         </ul>
 
       </div>
     </nav>
   </div>
 </template>
 
 <script>
 export default {
   name: 'MainNavigation',
   data() {
     return {
       activeIndex: null,
       navItems: [
       { title: this.$t('nav.home'), path: '/' },
        { 
          title: this.$t('nav.products'),
          path: "/product",
          children: [
            { name: this.$t('nav.fanSeries'), url: '/product/fan' }, 
            { name: this.$t('nav.lampSeries'), url: '/product/lamp' },
            { name: this.$t('nav.nightLight'), url: '/product/nightLight' },
            { name: this.$t('nav.mosquitoLamp'), url: '/product/mosquitoLamp' },
            { name: this.$t('nav.humidifier'), url: '/product/humidifier' },
            { name: this.$t('nav.heater'), url: '/product/heater' },
            { name: this.$t('nav.handWarmer'), url: '/product/handWarmer' },
            { name: this.$t('nav.ipSeries'), url: '/product/ipSeries' }
          ]
        },
        { 
          title: this.$t('nav.about'),
          path: "/about",
          children: [
            { name: this.$t('nav.brandIntro'), url: '/about' }, 
            { name: this.$t('nav.history'), url: '#' },
            { name: this.$t('nav.video'), url: '#' },
            { name: this.$t('nav.honors'), url: '#' }
          ]
        },
        { 
          title: this.$t('nav.news'),
           path: '/news',
          children: [
            { name: this.$t('nav.exhibition'), url: '#' }, 
            { name: this.$t('nav.companyNews'), url: '#' }
          ]
        },
        { 
          title: this.$t('nav.service'),
          path: '/service',
          children: [
            { name: this.$t('nav.contactUs'), url: '#' }
          ]
        },
        { 
          title: this.$t('nav.join'),
         path: '/recruitment',
          children: [
            { name: this.$t('nav.socialRecruitment'), url: '#' }, 
            { name: this.$t('nav.campusRecruitment'), url: '#' },
            { name: this.$t('nav.internalReferral'), url: '#' }
          ]
        },
         { 
           title: this.$t('nav.find'),
           
           children: [
            {
               name: '1688',
               url: 'https://lozky.1688.com/?spm=a360g.21633289.0.0.25b5410cfELvcy'
            }, 
            {
               name: '拼多多',
               url: 'https://mobile.yangkeduo.com/mall_page.html?mall_id=938939512&msn=jju6xnzeyustvktqchoc6wl6ni_axbuy&_sop_rcto'
            }
          ]
         },
         {
            title: this.$t('nav.language'),
            icon: 'el-icon-search',
            click: this.handleLanguageSwitch,
            isLanguageSwitch: true // 添加标识
         }
       ]
     }
   },
   methods: {
   //   handleClick(item) {
   //     // 处理点击事件，例如跳转页面等
   //     console.log('Clicked:', item.title);
   //   },
   handleClick(item) {
     if (item.isLanguageSwitch) {
       this.handleLanguageSwitch();
     } else if (item.path) {
       if (this.$route.path !== item.path) {
         this.$router.push(item.path)
       }
     } else if (item.url) {
       window.open(item.url, '_blank')
     }
   },
     goTo(child){
      window.open(child.url, '_blank')
     },
     handleLanguageSwitch() {
       console.log('Language switch handler called');
       const newLocale = this.$i18n.locale === 'zh' ? 'en' : 'zh';
       console.log('Setting locale to:', newLocale);
       this.$i18n.locale = newLocale;
       localStorage.setItem('userLanguage', newLocale);
      
       // 强制重新渲染整个应用
       this.$nextTick(() => {
         window.location.reload();
       });
     }
   }
 }
 </script>
 
 <style scoped>
 /* 基础样式 */
 .nav-container {
   padding: 0 20px;
   background: #fff;
 }
 
 .main-nav {
   display: flex;
   align-items: center;
   justify-content: space-between; /* 左右分布 */
   height: 10vh; /* 设置整体高度为200px */
   border-bottom: 1px solid #eee;
 }
 
 /* Logo样式 */
 .logo {
   width: 10%;
   margin-left:   calc((40% -  300px) / 2);/* 距离左侧的间距 */
 }
 .logo img {
   height: 10vh; /* 调整Logo尺寸以适应新的高度 */
   width: auto;
 }
 
 /* 右侧内容容器 */
 .right-content {
   display: flex;
   align-items: center;
   gap: 40px; /* 右侧内容之间的间距 */
   margin-right: calc((40% - 300px) / 2);
  
 }
 
 /* 导航菜单 */
 .nav-menu {
   display: flex;
   list-style: none; /* 移除默认列表样式 */
   margin: 0; /* 清除默认外边距 */
   padding: 0; /* 清除默认内边距 */
   column-gap: 40px;
   font-size: 1vw; /* 加大字体大小 */
   font-weight: bold; /* 加粗字体 */
   color: #333;
 }
 
 .nav-item {
   position: relative;
   cursor: pointer;
   transition: color 0.3s;
   list-style: none; /* 再次确认移除默认样式 */
 }
 
 .nav-item a {
   text-decoration: none;
   color: inherit;
   display: inline-block;
   padding-bottom: 10px;
   border-bottom: 3px solid transparent;
   transition: border-color 0.3s;
 }
 
 .nav-item a.active {
   color: #007bff;
   border-color: #007bff;
 }
 
 .nav-item:hover a {
   color: #007bff;
   border-color: #007bff;
 }
 
 /* 下拉菜单 */
 .dropdown-menu {
   position: absolute;
   left: 50%; /* 水平居中 */
   transform: translateX(-50%); /* 完全居中 */
   min-width: 180px;
   padding: 15px 0;
   background: #fff;
   box-shadow: 0 4px 12px rgba(0,0,0,0.1);
   border-radius: 4px;
   z-index: 100;
   border: 1px solid #ddd; /* 添加边框 */
   list-style: none; /* 移除默认列表样式 */
   margin: 0; /* 清除默认外边距 */
   padding: 0; /* 清除默认内边距 */
   text-align: center; /* 子项文字居中 */
 }
 
 .dropdown-item {
   list-style: none; /* 再次确认移除默认样式 */
   padding: 12px 20px;
   white-space: nowrap;
   border-bottom: 1px solid #ddd; /* 子项间的分隔线 */
   cursor: pointer;
   transition: background-color 0.3s;
   font-size: 0.7vw;
   color: grey;
 }
 
 .dropdown-item:last-child {
   border-bottom: 3px solid #007bff; /* 最后一个子项显示蓝色横线 */
 }
 
 .dropdown-item:hover {
   background-color: #f5f5f5; /* 鼠标悬停时的背景色 */
 }
 
 /* 语言切换 */
 .language-switch {
   font-size: 1vw; /* 字体大小与菜单一致 */
   font-weight: bold; /* 加粗字体 */
   color: #333;
   padding-bottom: 0.65vw;
   cursor: pointer;
 }
 
 .language-switch span {
   transition: color 0.3s;
 }
 
 .language-switch span:hover {
   color: #007bff;
 }
 
 /* 搜索图标 */
 .language-switch .el-icon-search {
   font-size: 30px; /* 图标稍大一些 */
   color: #333;
   cursor: pointer;
   transition: color 0.3s;
 }
 
 .language-switch .el-icon-search:hover {
   color: #007bff; /* 鼠标悬停时变蓝 */
 }
 </style>